var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 31,
    viewBox: "0 0 39 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "2dmsxsyuua",
    x: 0,
    y: 0,
    width: 39,
    height: 31,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#2dmsxsyuua)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 769",
    width: 27,
    height: 19,
    rx: 5,
    transform: "translate(6 5)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 893",
    d: "M10.972 16.5a.472.472 0 0 0 0 .944h3.777a.472.472 0 0 0 0-.944z",
    transform: "translate(6.333 -2.473)",
    style: {
      fill: "#777"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 894",
    d: "M11.887 6.693A5.193 5.193 0 1 1 6.693 1.5a5.193 5.193 0 0 1 5.194 5.193zm-.944 0a4.249 4.249 0 1 1-4.25-4.249 4.249 4.249 0 0 1 4.249 4.249z",
    style: {
      fillRule: "evenodd",
      fill: "#777"
    },
    transform: "translate(12.5 7.806)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.0fd51bcde1bc454a417c355f65d0f985.svg";
export { ForwardRef as ReactComponent };